const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";

const state = {
  activeTab: 'tutorial'
}

export const actions = {
  setActiveTab({commit}, activeTab){
    commit(SET_ACTIVE_TAB, activeTab)
  },
}

export const mutations = {
  [SET_ACTIVE_TAB] (state, activeTab) {
    state.activeTab = activeTab
  }
}

export const getters = {
  activeTab: state => {
    return state.activeTab
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/userKit.js